function dynamicDropdown() {
  const parentIndicator = "[-]";
  const childIndicator = "[--]";

  const parentElements = document.querySelectorAll("ul li");

  parentElements.forEach(function (parentElement) {
    const parentLink = parentElement.querySelector("a");
    if (parentLink && parentLink.textContent.includes(parentIndicator)) {
      const submenu = document.createElement("ul");
      submenu.classList.add("v-dropdown");

      const childElements = [];

      let siblingElement = parentElement.nextElementSibling;
      while (siblingElement && !siblingElement.querySelector("a").textContent.includes(parentIndicator)) {
        if (siblingElement.querySelector("a").textContent.includes(childIndicator)) {
          childElements.push(siblingElement);
        }
        siblingElement = siblingElement.nextElementSibling;
      }

      childElements.forEach(function (childElement) {
        submenu.appendChild(childElement.cloneNode(true)); // Clone the child element
        childElement.remove(); // Remove the original child element
      });

      parentElement.classList.add("has_dropdown"); // Add class to parent element

      const caretWrapper = document.createElement("span");
      caretWrapper.classList.add("v-caret-wrapper");

      const caretSVG = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      caretSVG.setAttribute("xmlns", "http://www.w3.org/2000/svg");
      caretSVG.setAttribute("viewBox", "0 0 330 330");
      caretSVG.setAttribute("fill", "CurrentColor");
      caretSVG.classList.add("caret-down");

      const caretPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
      caretPath.setAttribute("d", "m325.61 79.393c-5.857-5.857-15.355-5.858-21.213 1e-3l-139.39 139.39-139.4-139.39c-5.857-5.857-15.355-5.858-21.213 1e-3 -5.858 5.858-5.858 15.355 0 21.213l150 150c2.813 2.813 6.628 4.393 10.606 4.393s7.794-1.581 10.606-4.394l150-150c5.859-5.857 5.859-15.355 1e-3 -21.213z");

      caretSVG.appendChild(caretPath);
      caretWrapper.appendChild(caretSVG);
      parentElement.appendChild(caretWrapper);

      window.addEventListener("click", function (event) {
        if (!parentElement.contains(event.target)) {
          submenu.classList.remove("is_visible");
        }
      });

      caretWrapper.addEventListener("click", function(event) {
        event.preventDefault();
        
        // Check if the clicked dropdown is already open
        var isDropdownOpen = submenu.classList.contains("is_visible");
        
        // Close any previously opened dropdown
        var visibleDropdown = document.querySelector(".is_visible");
        if (visibleDropdown) {
          visibleDropdown.classList.remove("is_visible");
        }
        
        // Toggle visibility of the clicked dropdown
        if (!isDropdownOpen) {
          submenu.classList.add("is_visible");
        }
        
        event.stopPropagation();
      });

      parentElement.appendChild(submenu);
    }
  });

  removeText(parentIndicator);
  removeText(childIndicator);
}

function removeText(text) {
  const elements = document.querySelectorAll("nav .it-head-menu a");

  elements.forEach(function (element) {
    const caretWrapper = element.querySelector(".v-caret-wrapper");
    if (caretWrapper) {
      caretWrapper.remove(); // Remove existing caret wrappers
    }

    const originalText = element.textContent;
    element.textContent = originalText.replace(text, "").trim();

    if (caretWrapper) {
      element.appendChild(caretWrapper); // Append caret wrapper back to the element
    }
  });
}

  dynamicDropdown();